// Blog/Ratgeber Artikel Daten
export const articles = [
  {
    id: 'wie-gruende-ich-einen-bildungstraeger',
    slug: 'wie-gruende-ich-einen-bildungstraeger',
    title: 'Wie gründe ich einen Bildungsträger?',
    description: 'Von der Geschäftsidee bis zur AZAV-Zulassung: Die wichtigsten Schritte zur Gründung eines Bildungsträgers im Überblick.',
    metaDescription: 'Schritt-für-Schritt-Anleitung zur Gründung eines Bildungsträgers mit AZAV-Zulassung. Voraussetzungen, Ablauf und wichtige Tipps.',
    category: 'Gründung',
    readTime: '8 Min.',
    content: {
      intro: 'Die Gründung eines Bildungsträgers ist ein komplexer Prozess, der gute Vorbereitung erfordert. Wer geförderte Maßnahmen der Arbeitsagentur anbieten möchte, benötigt eine AZAV-Zulassung. Dieser Artikel gibt einen strukturierten Überblick über die wichtigsten Schritte.',
      sections: [
        {
          title: 'Voraussetzungen prüfen',
          content: 'Bevor Sie einen Bildungsträger gründen, sollten Sie die grundlegenden Voraussetzungen kennen. Dazu gehören: eine geeignete Rechtsform (GmbH, e.V., Einzelunternehmen), fachlich qualifiziertes Personal, geeignete Räumlichkeiten und ein tragfähiges Geschäftskonzept. Die Arbeitsagentur prüft bei der Zulassung unter anderem die finanzielle Leistungsfähigkeit und die fachliche Eignung.'
        },
        {
          title: 'Rechtsform wählen',
          content: 'Die Wahl der Rechtsform hängt von verschiedenen Faktoren ab. Eine GmbH bietet Haftungsbeschränkung, erfordert aber Stammkapital. Ein eingetragener Verein eignet sich für gemeinnützige Ausrichtung. Einzelunternehmen sind schnell gegründet, bieten aber keinen Haftungsschutz. Lassen Sie sich bei der Entscheidung steuerlich und rechtlich beraten.'
        },
        {
          title: 'Qualitätsmanagementsystem aufbauen',
          content: 'Für die AZAV-Zulassung benötigen Sie ein dokumentiertes Qualitätsmanagementsystem (QM-System). Dieses umfasst unter anderem: ein QM-Handbuch, Prozessbeschreibungen, Arbeitsanweisungen und Formulare. Das QM-System muss die Anforderungen der AZAV erfüllen und wird bei der Zulassung geprüft.'
        },
        {
          title: 'Zertifizierungsstelle wählen',
          content: 'Die AZAV-Zulassung erfolgt durch eine fachkundige Stelle (FKS). Es gibt mehrere zugelassene Zertifizierungsstellen in Deutschland. Vergleichen Sie Preise und Leistungen. Achten Sie auf Erfahrung im Bildungsbereich und transparente Kommunikation.'
        },
        {
          title: 'Zulassungsantrag stellen',
          content: 'Nach Aufbau des QM-Systems stellen Sie den Antrag bei der gewählten FKS. Der Antrag umfasst umfangreiche Unterlagen: Gesellschaftsvertrag, Handelsregisterauszug, Organigramm, QM-Dokumentation, Raumkonzept, Personalübersicht und mehr. Die FKS prüft die Unterlagen und führt ein Audit durch.'
        }
      ],
      consultingSection: {
        title: 'Wann lohnt sich Beratung?',
        content: 'Die Gründung eines Bildungsträgers ist aufwendig. Fehler im Zulassungsprozess kosten Zeit und Geld. Eine professionelle Beratung lohnt sich besonders, wenn Sie keine Erfahrung mit AZAV-Zulassungen haben, das QM-System von Grund auf aufbauen müssen oder schnell starten möchten. Ein erfahrener Berater kennt die Anforderungen und typischen Stolperfallen.'
      }
    }
  },
  {
    id: 'was-ist-die-azav',
    slug: 'was-ist-die-azav',
    title: 'Was ist die AZAV?',
    description: 'Die Akkreditierungs- und Zulassungsverordnung Arbeitsförderung erklärt: Grundlagen, Zweck und Bedeutung für Bildungsträger.',
    metaDescription: 'Was bedeutet AZAV? Erklärung der Akkreditierungs- und Zulassungsverordnung Arbeitsförderung für Bildungsträger und Maßnahmen.',
    category: 'Grundlagen',
    readTime: '6 Min.',
    content: {
      intro: 'AZAV steht für Akkreditierungs- und Zulassungsverordnung Arbeitsförderung. Sie regelt, welche Anforderungen Bildungsträger erfüllen müssen, um Maßnahmen der Arbeitsförderung durchführen zu dürfen. Ohne AZAV-Zulassung keine Förderung durch die Arbeitsagentur.',
      sections: [
        {
          title: 'Rechtlicher Hintergrund',
          content: 'Die AZAV ist eine Verordnung auf Grundlage des Sozialgesetzbuches III (SGB III). Sie löste 2012 die frühere AZWV ab. Ziel ist die Qualitätssicherung bei Maßnahmen der Arbeitsförderung. Die Verordnung definiert Anforderungen an Träger und Maßnahmen sowie das Zulassungsverfahren.'
        },
        {
          title: 'Trägerzulassung vs. Maßnahmezulassung',
          content: 'Die AZAV unterscheidet zwei Zulassungsebenen. Die Trägerzulassung bestätigt, dass ein Bildungsträger grundsätzlich geeignet ist, Maßnahmen durchzuführen. Die Maßnahmezulassung bezieht sich auf konkrete Bildungsangebote. Beide Zulassungen sind Voraussetzung für die Förderung durch Bildungsgutscheine.'
        },
        {
          title: 'Anforderungen an Träger',
          content: 'Für die Trägerzulassung müssen Sie nachweisen: ein funktionierendes Qualitätsmanagementsystem, fachlich und pädagogisch geeignetes Personal, angemessene Räumlichkeiten und Ausstattung, finanzielle Leistungsfähigkeit sowie Zuverlässigkeit der Leitungspersonen.'
        },
        {
          title: 'Fachkundige Stellen (FKS)',
          content: 'Die Zulassung erfolgt nicht durch die Arbeitsagentur selbst, sondern durch sogenannte fachkundige Stellen. Diese sind privatwirtschaftliche Zertifizierungsunternehmen, die von der Deutschen Akkreditierungsstelle (DAkkS) zugelassen werden. Die FKS prüft und überwacht die Einhaltung der AZAV-Anforderungen.'
        },
        {
          title: 'Gültigkeit und Überwachung',
          content: 'Eine AZAV-Trägerzulassung ist in der Regel fünf Jahre gültig. In diesem Zeitraum finden jährliche Überwachungsaudits statt. Nach Ablauf ist eine Re-Zertifizierung erforderlich. Bei schwerwiegenden Mängeln kann die Zulassung auch vorzeitig entzogen werden.'
        }
      ],
      consultingSection: {
        title: 'Wann lohnt sich Beratung?',
        content: 'Die AZAV-Anforderungen sind umfangreich und ändern sich gelegentlich. Eine Beratung ist sinnvoll, wenn Sie neu in das Thema einsteigen, Ihr bestehendes QM-System an die AZAV anpassen müssen oder unsicher sind, ob Ihre Dokumentation den Anforderungen entspricht.'
      }
    }
  },
  {
    id: 'ablauf-azav-traegerzulassung',
    slug: 'ablauf-azav-traegerzulassung',
    title: 'Ablauf der AZAV-Trägerzulassung',
    description: 'Der komplette Ablauf einer AZAV-Trägerzulassung: Von der Vorbereitung über das Audit bis zur Zertifikatsvergabe.',
    metaDescription: 'Wie läuft eine AZAV-Trägerzulassung ab? Phasen, Zeitrahmen und Tipps für eine erfolgreiche Zertifizierung.',
    category: 'Zulassung',
    readTime: '7 Min.',
    content: {
      intro: 'Der Weg zur AZAV-Trägerzulassung folgt einem strukturierten Ablauf. Von der ersten Vorbereitung bis zum Erhalt des Zertifikats vergehen typischerweise mehrere Monate. Dieser Artikel erklärt die einzelnen Phasen.',
      sections: [
        {
          title: 'Phase 1: Vorbereitung',
          content: 'In der Vorbereitungsphase bauen Sie Ihr Qualitätsmanagementsystem auf oder passen es an die AZAV-Anforderungen an. Dazu gehören: Erstellung des QM-Handbuchs, Definition von Prozessen, Schulung der Mitarbeiter und Vorbereitung der erforderlichen Nachweise. Diese Phase dauert je nach Ausgangslage 4–12 Wochen.'
        },
        {
          title: 'Phase 2: Auswahl der fachkundigen Stelle',
          content: 'Wählen Sie eine fachkundige Stelle (FKS) für die Zertifizierung. Holen Sie Angebote ein und vergleichen Sie Preise, Termine und Service. Achten Sie auf Erfahrung im Bildungsbereich. Nach Auftragserteilung erhalten Sie Informationen zum weiteren Ablauf.'
        },
        {
          title: 'Phase 3: Dokumentenprüfung',
          content: 'Die FKS prüft zunächst Ihre eingereichten Unterlagen. Dazu gehören: QM-Dokumentation, Gesellschaftsunterlagen, Personalübersicht, Raumkonzept und weitere Nachweise. Bei Unvollständigkeit oder Mängeln erhalten Sie Rückmeldung zur Nachbesserung.'
        },
        {
          title: 'Phase 4: Audit vor Ort',
          content: 'Nach erfolgreicher Dokumentenprüfung findet das Audit vor Ort statt. Der Auditor prüft, ob das QM-System gelebt wird und die Angaben der Realität entsprechen. Er führt Gespräche mit Mitarbeitern, sichtet Unterlagen und besichtigt die Räumlichkeiten. Das Audit dauert in der Regel einen Tag.'
        },
        {
          title: 'Phase 5: Auditbericht und Zertifikat',
          content: 'Nach dem Audit erstellt der Auditor einen Bericht. Bei positivem Ergebnis wird das Zertifikat ausgestellt. Bei Abweichungen müssen Sie innerhalb einer Frist Korrekturmaßnahmen nachweisen. Erst nach erfolgreicher Nachbesserung erhalten Sie die Zulassung.'
        },
        {
          title: 'Zeitrahmen und Kosten',
          content: 'Der gesamte Prozess dauert bei guter Vorbereitung etwa 2–4 Monate. Die Kosten für die Zertifizierung variieren je nach FKS und Unternehmensgröße. Rechnen Sie mit Gebühren im mittleren vierstelligen Bereich für Erstzertifizierung und Überwachungsaudits.'
        }
      ],
      consultingSection: {
        title: 'Wann lohnt sich Beratung?',
        content: 'Eine professionelle Begleitung verkürzt den Prozess und erhöht die Erfolgschancen. Besonders bei Erstzzulassungen ist externe Unterstützung sinnvoll. Ein erfahrener Berater kennt die Anforderungen der Auditoren und kann Sie gezielt vorbereiten.'
      }
    }
  },
  {
    id: 'was-kostet-azav-zulassung',
    slug: 'was-kostet-azav-zulassung',
    title: 'Was kostet eine AZAV-Zulassung?',
    description: 'Überblick über die Kosten einer AZAV-Zulassung: Zertifizierungsgebühren, Beratungskosten und laufende Aufwände.',
    metaDescription: 'Kosten der AZAV-Zulassung im Überblick: Zertifizierungsgebühren, Beratung, QM-System und laufende Kosten für Bildungsträger.',
    category: 'Kosten',
    readTime: '5 Min.',
    content: {
      intro: 'Die Kosten einer AZAV-Zulassung setzen sich aus verschiedenen Komponenten zusammen. Neben den Gebühren der Zertifizierungsstelle fallen oft Kosten für Beratung, QM-Aufbau und laufende Pflege an. Ein realistischer Überblick.',
      sections: [
        {
          title: 'Zertifizierungsgebühren',
          content: 'Die fachkundigen Stellen berechnen Gebühren für die Zulassung. Für eine Erstzertifizierung liegen diese typischerweise zwischen 2.500 und 5.000 Euro – abhängig von Unternehmensgröße und Anzahl der Standorte. Hinzu kommen jährliche Überwachungsaudits mit Kosten von etwa 1.500 bis 2.500 Euro.'
        },
        {
          title: 'Kosten für QM-Aufbau',
          content: 'Der Aufbau eines AZAV-konformen QM-Systems erfordert Zeit und oft externe Unterstützung. Wenn Sie ein QM-System von Grund auf erstellen lassen, rechnen Sie mit Kosten im mittleren vierstelligen Bereich. Fertige Musterunterlagen sind günstiger, erfordern aber Anpassungsarbeit.'
        },
        {
          title: 'Beratungskosten',
          content: 'Professionelle AZAV-Beratung kostet je nach Umfang unterschiedlich. Eine Komplettbegleitung von der Vorbereitung bis zum Audit liegt typischerweise zwischen 3.000 und 8.000 Euro. Einzelne Beratungsleistungen wie Dokumentencheck oder Audit-Vorbereitung sind entsprechend günstiger.'
        },
        {
          title: 'Laufende Kosten',
          content: 'Nach der Zulassung fallen laufende Kosten an: jährliche Überwachungsaudits, Pflege des QM-Systems, Schulungen und ggf. externe QM-Betreuung. Planen Sie jährlich mindestens 2.000 bis 4.000 Euro für die Aufrechterhaltung der Zulassung ein.'
        },
        {
          title: 'Gesamtkalkulation',
          content: 'Für eine realistische Kalkulation: Die Erstzzulassung kostet inklusive QM-Aufbau und Beratung etwa 5.000 bis 15.000 Euro. Die jährlichen Folgekosten liegen bei 3.000 bis 6.000 Euro. Diese Investition rechnet sich, wenn Sie regelmäßig geförderte Maßnahmen durchführen.'
        }
      ],
      consultingSection: {
        title: 'Wann lohnt sich Beratung?',
        content: 'Beratung verursacht zunächst Kosten, spart aber oft Geld. Fehler im Zulassungsprozess führen zu Verzögerungen und Nacharbeiten. Ein erfahrener Berater hilft, den Prozess effizient zu gestalten und Folgekosten durch mangelhafte QM-Systeme zu vermeiden.'
      }
    }
  },
  {
    id: 'internes-audit-azav-pflicht',
    slug: 'internes-audit-azav-pflicht',
    title: 'Internes Audit nach AZAV – was ist Pflicht?',
    description: 'Das interne Audit ist Pflicht für jeden AZAV-Träger. Was geprüft wird, wie oft es stattfinden muss und wer es durchführen darf.',
    metaDescription: 'Internes Audit nach AZAV: Pflichten, Ablauf und Anforderungen für Bildungsträger. Was wird geprüft und wie oft?',
    category: 'QM-System',
    readTime: '6 Min.',
    content: {
      intro: 'Jeder AZAV-zugelassene Bildungsträger muss regelmäßig interne Audits durchführen. Dies ist keine optionale Maßnahme, sondern eine verbindliche Anforderung. Was genau dahintersteckt und wie Sie es richtig umsetzen.',
      sections: [
        {
          title: 'Warum interne Audits Pflicht sind',
          content: 'Interne Audits sind ein zentrales Element des Qualitätsmanagements. Sie dienen der Selbstüberwachung und kontinuierlichen Verbesserung. Die AZAV fordert den Nachweis, dass das QM-System funktioniert und weiterentwickelt wird. Ohne dokumentierte interne Audits riskieren Sie Probleme im Überwachungsaudit.'
        },
        {
          title: 'Häufigkeit und Umfang',
          content: 'Das interne Audit muss mindestens einmal jährlich stattfinden. Es soll alle relevanten Bereiche des QM-Systems abdecken – nicht unbedingt in einem Durchgang, aber über einen Auditzyklusszyklus. Typische Prüfbereiche: Leitungsprozesse, Kernprozesse der Bildungsarbeit, unterstützende Prozesse und Dokumentation.'
        },
        {
          title: 'Wer darf das interne Audit durchführen?',
          content: 'Der interne Auditor muss unabhängig vom geprüften Bereich sein – Sie dürfen nicht Ihre eigene Arbeit auditieren. In kleinen Organisationen ist das oft schwierig. Deshalb beauftragen viele Träger externe Auditoren. Diese bringen zudem frischen Blick und Erfahrung mit.'
        },
        {
          title: 'Ablauf eines internen Audits',
          content: 'Ein typisches internes Audit umfasst: Vorbereitung und Planung, Prüfung von Dokumenten und Aufzeichnungen, Gespräche mit Mitarbeitern, Begehung der Räumlichkeiten sowie die Erstellung eines Auditberichts. Festgestellte Abweichungen müssen dokumentiert und bearbeitet werden.'
        },
        {
          title: 'Dokumentation und Nachverfolgung',
          content: 'Das Auditergebnis muss schriftlich dokumentiert werden. Der Bericht enthält: Auditdatum, geprüfte Bereiche, Feststellungen, Abweichungen und Verbesserungspotenziale. Korrekturmaßnahmen sind zu definieren, umzusetzen und auf Wirksamkeit zu prüfen. Diese Dokumentation wird im Überwachungsaudit geprüft.'
        }
      ],
      consultingSection: {
        title: 'Wann lohnt sich Beratung?',
        content: 'Viele Träger unterschätzen den Aufwand für interne Audits oder führen sie nur oberflächlich durch. Ein externer Auditor bringt Objektivität und Erfahrung. Er identifiziert Schwachstellen, bevor es der Zertifizierungsauditor tut. Das spart unangenehme Überraschungen im Überwachungsaudit.'
      }
    }
  }
];

export const getArticleBySlug = (slug) => {
  return articles.find(article => article.slug === slug);
};
